export * from './console-collector';
export * from './network-collector';
export * from './env-collector';
export * from './screenshot';

import type { UserFeedbackDiagnostics } from '@safetyhub/shared';
import { getRecentConsoleLogs } from './console-collector';
import { getRecentNetworkRequests } from './network-collector';
import { collectBrowserInfo, getCurrentUrl, getAppVersion } from './env-collector';

/**
 * 진단 데이터 전체를 한 번에 수집합니다.
 * 스크린샷은 별도로 captureScreenshot()을 호출하세요.
 */
export function collectDiagnostics(): UserFeedbackDiagnostics {
  return {
    browserInfo: collectBrowserInfo(),
    consoleErrors: getRecentConsoleLogs(),
    networkRequests: getRecentNetworkRequests(),
    currentUrl: getCurrentUrl(),
    appVersion: getAppVersion(),
  };
}
